/* Odd World Studio: home page scroll effects (Atomic Aero).
   - Pinned product showcase that moves sideways as you scroll (desktop)
   - Reveal-on-scroll for sections and product cards
   - Gentle hero parallax, spinning orbit
   - Glossy tilt on cards
   Everything is skipped when the visitor prefers reduced motion. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var wide = window.matchMedia('(min-width: 821px)');
  if (reduce.matches) { root.classList.add('owa-still'); return; }
  root.classList.add('owa-motion');

  /* ---------- Reveal on scroll ---------- */
  function markReveals() {
    var sel = [
      '.index-sections > .shopify-section:not([class*="shopify-section--ows-"])',
      '.index-sections .thumbnail',
      '.owa-cat',
      '.owa-lab__card'
    ].join(',');
    var els = document.querySelectorAll(sel);
    els.forEach(function (el) {
      if (el.hasAttribute('data-owa-reveal')) return;
      el.setAttribute('data-owa-reveal', '');
      // stagger siblings in a row
      var parent = el.parentElement, idx = 0;
      if (parent) idx = Array.prototype.indexOf.call(parent.children, el) % 6;
      el.style.setProperty('--owa-d', (idx * 70) + 'ms');
    });
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Pinned showcase ---------- */
  var shows = [];
  function setupShows() {
    shows = Array.prototype.map.call(document.querySelectorAll('[data-owa-show]'), function (sec) {
      return { sec: sec, pin: sec.querySelector('.owa-show__pin'), track: sec.querySelector('.owa-show__track'),
               bar: sec.querySelector('.owa-show__bar i'), travel: 0 };
    });
    sizeShows();
  }
  function sizeShows() {
    shows.forEach(function (s) {
      if (!wide.matches) { s.sec.style.height = ''; s.sec.classList.remove('is-pinned'); s.track.style.transform = ''; return; }
      s.sec.classList.add('is-pinned');
      var vw = window.innerWidth, vh = window.innerHeight;
      s.travel = Math.max(0, s.track.scrollWidth - vw + 80);
      s.sec.style.height = (vh + s.travel) + 'px';
    });
  }

  /* ---------- Scroll loop ---------- */
  var heroImg = document.querySelector('.owa-hero__photo > img:not(.owa-deco)');
  var spinners = document.querySelectorAll('.owa-hero__orbit, [data-owa-spin]');
  var ticking = false;
  function frame() {
    ticking = false;
    var y = window.scrollY, vh = window.innerHeight;
    if (heroImg) {
      var hp = Math.min(1, y / vh);
      heroImg.style.transform = 'translate3d(0,' + (hp * 40).toFixed(1) + 'px,0) scale(' + (1.04 - hp * 0.04).toFixed(3) + ')';
    }
    spinners.forEach(function (el) { el.style.transform = 'rotate(' + (y * 0.12).toFixed(1) + 'deg)'; });
    shows.forEach(function (s) {
      var r = s.sec.getBoundingClientRect();
      var total = Math.max(1, s.sec.offsetHeight - vh);
      var p = Math.min(1, Math.max(0, -r.top / total));
      s.sec.style.setProperty('--p', p.toFixed(4));
      if (s.sec.classList.contains('is-pinned')) {
        s.track.style.transform = 'translate3d(' + (-p * s.travel).toFixed(1) + 'px,0,0)';
      }
      if (s.bar) s.bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      // headline settles in as the section arrives
      var arrive = Math.min(1, Math.max(0, 1 - r.top / vh));
      s.sec.style.setProperty('--a', arrive.toFixed(4));
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

  /* ---------- Glossy tilt ---------- */
  function setupTilt() {
    if (!window.matchMedia('(hover: hover)').matches) return;
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('[data-owa-tilt], .index-sections .thumbnail > a');
      if (!card) return;
      var b = card.getBoundingClientRect();
      var x = (e.clientX - b.left) / b.width - 0.5, yy = (e.clientY - b.top) / b.height - 0.5;
      card.style.setProperty('--rx', (-yy * 8).toFixed(2) + 'deg');
      card.style.setProperty('--ry', (x * 10).toFixed(2) + 'deg');
      card.style.setProperty('--gx', ((x + 0.5) * 100).toFixed(1) + '%');
      card.classList.add('is-tilt');
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      var card = e.target.closest && e.target.closest('[data-owa-tilt], .index-sections .thumbnail > a');
      if (card && !card.contains(e.relatedTarget)) { card.classList.remove('is-tilt'); card.style.removeProperty('--rx'); card.style.removeProperty('--ry'); }
    }, { passive: true });
  }

  function init() {
    markReveals();
    setupShows();
    setupTilt();
    frame();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { sizeShows(); onScroll(); });
    window.addEventListener('load', function () { sizeShows(); onScroll(); });
    if (wide.addEventListener) wide.addEventListener('change', function () { sizeShows(); onScroll(); });
    // theme editor: re-run when sections are added/changed
    document.addEventListener('shopify:section:load', function () { markReveals(); setupShows(); onScroll(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
